import { render, staticRenderFns } from "./admin_page.vue?vue&type=template&id=770cf5f0&scoped=true"
import script from "./admin_page.vue?vue&type=script&lang=js"
export * from "./admin_page.vue?vue&type=script&lang=js"
import style0 from "./admin_page.vue?vue&type=style&index=0&id=770cf5f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770cf5f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770cf5f0')) {
      api.createRecord('770cf5f0', component.options)
    } else {
      api.reload('770cf5f0', component.options)
    }
    module.hot.accept("./admin_page.vue?vue&type=template&id=770cf5f0&scoped=true", function () {
      api.rerender('770cf5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/user/admin_page.vue"
export default component.exports